/**
 * [INPUT]: 依赖 @/zinnercms-design-system/lib/utils 的 cn 合并 className
 * [OUTPUT]: 对外提供 LoadingDots 默认导出，以及 PageLoading、InlineLoading、TableLoading 三种密度的安静脉冲加载态
 * [POS]: components 的短时加载反馈组件组，补充 skeletons 的数据骨架职责，仅用于页面路由、行内操作和弹窗详情
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */

import { cn } from '@/zinnercms-design-system/lib/utils'

export default function LoadingDots({ className, size = 'md' }) {
  const sizeMap = {
    sm: 'h-1 w-1',
    md: 'h-1.5 w-1.5',
    lg: 'h-1.5 w-3',
    xl: 'h-2 w-4'
  }

  const dotSize = sizeMap[size] || sizeMap.md

  return (
    <div role="status" aria-label="加载中" className={cn('flex items-center justify-center gap-1.5', className)}>
      {[0, 160, 320].map((delay) => (
        <span
          key={delay}
          aria-hidden="true"
          className={cn(dotSize, 'rounded-full bg-primary/75 animate-pulse')}
          style={{ animationDelay: `${delay}ms`, animationDuration: '900ms' }}
        />
      ))}
    </div>
  )
}

/* ========================================
   页面级 Loading 组件
   用于整页加载状态
   ======================================== */
export function PageLoading({ message = '加载中' }) {
  return (
    <div className="flex min-h-[240px] w-full flex-col items-center justify-center gap-3">
      <LoadingDots size="lg" />
      <span className="text-xs font-medium tracking-wide text-muted-foreground">{message}</span>
    </div>
  )
}

/* ========================================
   行内 Loading 组件
   用于按钮、表格单元格等
   ======================================== */
export function InlineLoading({ className }) {
  return <LoadingDots size="sm" className={className} />
}

/* ========================================
   表格 Loading 组件
   用于表格 colSpan 单元格内的加载状态
   ======================================== */
export function TableLoading({ message = '加载中' }) {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-3 py-10">
      <LoadingDots size="md" />
      <span className="text-sm text-muted-foreground">{message}</span>
    </div>
  )
}
